import * as React from 'react';
import { BankTarget } from '../../types/types';

const renderSectionItem = (itemName, index) => {
    return <div key={index}
        className="item-validation d-flex mb-2 text-lato text-secondary-lighten-3">
        - {itemName}
    </div>;
};

const getSectionItems = (items) => {
    return Object.keys(items).map((subItem, index) => {
        return items[subItem].hasError ? renderSectionItem(items[subItem].name, index) : null;
    });
};

const MissingLoanRequiredFieldsView: React.FC<any> = (props) => {
    const { previewSubMenuErrors, target, onClose } = props;
    let c = 1;
    return <React.Fragment>
        <div className="text-lato text-secondary-lighten-3 text-left mb-4">
            Existen campos que faltan por llenar, por favor completa estos campos para enviar a
            {target.id === BankTarget.CREDITO_REAL ? ' Crédito Real' : ' Turbo Cash'}
        </div>
        <div className="modal-loan-validation">
            {
                Object.keys(previewSubMenuErrors).map((item, index) => {
                    const sectionItems = getSectionItems(previewSubMenuErrors[item].fields);
                    const hasSectionItem = sectionItems.reduce((result: boolean, item: any) => {
                        return result || !!item;
                    }, false);
                    return hasSectionItem && <div className="col" key={index}>
                        <div className="d-flex text-lato text-secondary-lighten-3 font-weight-bold">
                            {c += 1}. {previewSubMenuErrors[item].sectionTitle}
                        </div>
                        <div className="wrapper-item-validation mt-2 pl-2">
                            {sectionItems}
                        </div>
                    </div>;
                })
            }
        </div>
        <div className="pt-3 px-0 text-right text-right pr-1 border-top">
            <a className="h-auto btn btn-link border-0 btn-form text-primary py-0 pr-0"
                onClick={() => onClose()}>Aceptar</a>
        </div>
    </React.Fragment>;
};

export default MissingLoanRequiredFieldsView;